if (!customElements.get('video-element')) {
  class VideoElement extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.toggleBtn = this.querySelector('[data-toggle-btn]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.video.addEventListener('play', () => {
        this.classList.add('is-playing');
      });

      this.video.addEventListener('pause', () => {
        this.classList.remove('is-playing');
      });

      this.toggleBtn.addEventListener('click', this.toggleVideo.bind(this));
    }

    toggleVideo() {
      if (this.classList.contains('is-playing')) {
        this.pause();
      } else {
        this.play();
      }
    }

    play() {
      this.video.play();
    }

    pause() {
      this.video.pause();
    }
  }

  customElements.define('video-element', VideoElement);
}
